var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"code",staticClass:"c-input-code",class:{
    'c-input-code--error': _vm.error
  },attrs:{"type":"tel","id":_vm.id,"name":_vm.name,"error":_vm.error},domProps:{"value":_vm.numberValue},on:{"keyup":_vm.validateValue,"input":_vm.updateValue,"focus":_vm.focus}})}
var staticRenderFns = []

export { render, staticRenderFns }